export default {
  form: {
    versions: {
      label: 'Versão',
      placeholder: 'Selecionar versão',
    },
    font_family: {
      label: 'Família de tipos de letra',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    promo_frame_primary_color: {
      label: 'Cor da moldura promocional',
    },
    promo_frame_discount_label_color: {
      label: 'Cor do desconto da moldura promocional',
    },
    vip_members_cta_color: {
      label: 'Cor do CTA de membros VIP',
    },
    url_cta_color: {
      label: 'Cor do CTA do URL',
    },
    url_color: {
      label: 'Cor do URL',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Cor do contorno do código QR',
    },
    qr_code_background_color: {
      label: 'Cor de fundo do código QR',
    },
    footer_background_color: {
      label: 'Cor de fundo do rodapé',
    },
    logo_zoom: {
      label: 'Tamanho do logótipo',
    },
    logo: {
      label: 'Logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o autocolante',
  },
};
